import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["message"];
  static values = {
    storageKey: String,
    defaultVisible: { type: Boolean, default: true }
  };

  connect() {
    if (this.hasStorageKeyValue && this.hasDefaultVisibleValue) {
      this.checkStorageState();
    }
  }

  checkStorageState() {
    const isClosed = localStorage.getItem(this.storageKeyValue) === 'true';
    if (isClosed && this.defaultVisibleValue) {
      this.messageTarget.style.display = 'none';
    }
  }

  close() {
    this.messageTarget.remove();

    // Store the closed state in localStorage if a storage key is provided
    if (this.hasStorageKeyValue) {
      localStorage.setItem(this.storageKeyValue, 'true');
    }
  }
}
